/* Hook encargado de hacer la consulta a la base y 
traer los mensajes

Autor: Benjamín León
Fecha: 2024-12-06
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'
import Message from '../interfaces/Message.ts'

import { makeUrlMessage, makeUrlMessageDetail } from './connectionData.tsx'

const useMessageFetcher = () => {
  const [errorMessage, setErrorMessage] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchMessages = async (orgId: string, status: number) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlMessage(orgId, status)
      const messages = await customFetch<Message[]>(apiUrl)

      setErrorMessage(null)

      return messages
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorMessage(myErr)

      return []
    } finally {
      setLoading(false)
    }
  }

  const fetchMessageDetail = async (id: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlMessageDetail(id)
      const message = await customFetch<Message>(apiUrl)

      setErrorMessage(null)

      return message
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorMessage(myErr)

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorMessage, loading, fetchMessages, fetchMessageDetail }
}

export default useMessageFetcher
